export const DEFAULT_WELLS = [
  { id: 1, outputCells: 1000, estimatedFrequency: 5.0 },
  { id: 2, outputCells: 1000, estimatedFrequency: 10.0 },
  { id: 3, outputCells: 0, estimatedFrequency: 0 },
  { id: 4, outputCells: 0, estimatedFrequency: 0 },
  { id: 5, outputCells: 0, estimatedFrequency: 0 },
  { id: 6, outputCells: 0, estimatedFrequency: 0 }
]

export const EXPERIMENT_VALIDATION_CONSTANTS = {
  MAX_CELLS_PER_WELL_PURITY: 8500,
  MAX_CELLS_PER_WELL_YIELD: 8000,
  MIN_TARGET_FREQUENCY: 0,
  MAX_TARGET_FREQUENCY: 100,
} as const

export const DEFAULT_EXPERIMENT_GOALS = ['imaging', 'purity', 'yield'] as const

// Default concentration values for each experiment mode
export const DEFAULT_CONCENTRATIONS = {
  imaging: 4,
  purity: 4,
  yield: 4
} as const

// Default sample volume values for each experiment mode
export const DEFAULT_SAMPLE_VOLUMES = {
  imaging: 0.408,
  purity: 0.408,
  yield: 0.408
} as const

// Maximum concentration values for slider limits
export const MAX_CONCENTRATIONS = {
  imaging: 10,     // 10e6/ml for imaging
  purity: 6.666,   // 6.666e6/ml for high purity sort (displayed as 6.7e6/ml)
  yield: 6.666     // 6.666e6/ml for high yield sort (displayed as 6.7e6/ml)
} as const

// Default values for experiment data
export const DEFAULT_EXPERIMENT_VALUES = {
  CELLS_TO_IMAGE: 50000,
  ESTIMATED_RUN_DURATION: 15,
  DEFAULT_CELL_RATE_FALLBACK: 100, // cells/s fallback when no metrics available
  DEFAULT_DURATION_DISPLAY: '15m',
} as const

// Conversion constants
export const CONVERSION_CONSTANTS = {
  CELLS_PER_ML_TO_MILLION: 1000000,
  PERCENTAGE_TO_FRACTION: 100,
} as const

// Helper type for experiment goals
export type ExperimentGoal = typeof DEFAULT_EXPERIMENT_GOALS[number]

// Factory function to create default experiment data
export const createDefaultExperimentData = (goal: ExperimentGoal = 'imaging'): {
  experimentGoal: ExperimentGoal
  cellsToImage: number
  cellConcentration: number
  minInputSampleVolume: number
  imagingConcentration: number
  purityConcentration: number
  yieldConcentration: number
  imagingSampleVolume: number
  puritySampleVolume: number
  yieldSampleVolume: number
  estimatedRunDuration: number
  wells: { id: number; outputCells: number; estimatedFrequency: number }[]
} => {
  const defaultConcentration = DEFAULT_CONCENTRATIONS[goal]
  const defaultVolume = DEFAULT_SAMPLE_VOLUMES[goal]

  return {
    experimentGoal: goal,
    cellsToImage: DEFAULT_EXPERIMENT_VALUES.CELLS_TO_IMAGE,
    cellConcentration: defaultConcentration,
    minInputSampleVolume: defaultVolume,
    imagingConcentration: DEFAULT_CONCENTRATIONS.imaging,
    purityConcentration: DEFAULT_CONCENTRATIONS.purity,
    yieldConcentration: DEFAULT_CONCENTRATIONS.yield,
    imagingSampleVolume: DEFAULT_SAMPLE_VOLUMES.imaging,
    puritySampleVolume: DEFAULT_SAMPLE_VOLUMES.purity,
    yieldSampleVolume: DEFAULT_SAMPLE_VOLUMES.yield,
    estimatedRunDuration: DEFAULT_EXPERIMENT_VALUES.ESTIMATED_RUN_DURATION,
    wells: [...DEFAULT_WELLS]
  }
}